import React from "react";
import { useQuery } from "@apollo/client";
import { HeaderDetail } from "./header-detail";
import { CasesSendReportHeaderDetailContainerArchivedSendReportCaseSummaryDocument, CasesSendReportHeaderDetailContainerArchivedSendReportCaseSummaryFieldsFragment } from "../../../../../../generated";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";

interface HeaderDetailContainerProps {
  caseId: string;
}

export const HeaderDetailContainer: React.FC<HeaderDetailContainerProps> = (props) => {
  const {
    data: archivedApplicantDetailData,
    loading: archivedApplicantDetailLoading,
    error: archivedApplicantDetailError,
  } = useQuery(
    CasesSendReportHeaderDetailContainerArchivedSendReportCaseSummaryDocument,
    {
      variables: {
        archivedSendReportCaseSummaryId: props?.caseId,
      },
    }
  );

  return (
    <ComponentQueryLoader
      loading={archivedApplicantDetailLoading}
      hasData={archivedApplicantDetailData}
      error={archivedApplicantDetailError}
      hasDataComponent={
        <HeaderDetail
          data={
            archivedApplicantDetailData?.archivedSendReportCaseSummary as CasesSendReportHeaderDetailContainerArchivedSendReportCaseSummaryFieldsFragment
          }
        />
      }
    />
  );
};
